export const TOP_OFFER = {
  enabled: true,

  // Main Heading
  text: "Welcome to Shringar ✨",

  // Sub text (brand message)
  subText:
    "Hello happy customers! We are currently offering bags & purses. More categories coming soon as we grow.",

  // Colors (Luxury Theme)
  backgroundColor: "#f20808",   
  textColor: "rgb(251, 251, 250)"          
};


export const UTILITY_LINKS = [
  { label: "Track Package", path: "/track-order" },
  { label: "Return & Exchange", path: "/returns" },
  { label: "Contact Us", path: "/contact" }
];